import { createClient } from "@supabase/supabase-js";

export type SharedSupabaseClientConfig = {
  url?: string;
  anonKey?: string;
  options?: Parameters<typeof createClient>[2];
};

export function createSharedSupabaseClient<Database = unknown>(
  config: SharedSupabaseClientConfig = {},
) {
  const url = config.url ?? import.meta.env.VITE_SUPABASE_URL;
  const key = config.anonKey ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!url || !key) {
    throw new Error("Missing Supabase env vars for shared client");
  }

  return createClient<Database>(url, key, config.options);
}
